import Responsive from "components/Responsive";
import { Popup as IParquePopup } from "iparque-components";
import React, { ReactNode } from "react";
import { breakpoints } from "theme/breakpoints";
import { StyledButton, ContentContainer } from "./styles";

interface PopupProps {
  visible: boolean;
  onClose: () => void;
  icon: ReactNode;
  buttonText: string;
  onClickButton: () => void;
}

const PasswordRequirementsPopup: React.FC<PopupProps> = ({
  visible,
  onClose,
  icon,
  buttonText,
  onClickButton,
  children,
}) => {
  return (
    <IParquePopup visible={visible} onClose={onClose}>
      <ContentContainer className="mt-10">
        <Responsive minWidth={breakpoints.md}>{icon}</Responsive>
        <div>{children}</div>
      </ContentContainer>
      <StyledButton
        className="mt-20 mb-10"
        onClick={onClickButton}
        color="secondary"
        size="xs"
      >
        {buttonText}
      </StyledButton>
    </IParquePopup>
  );
};

export default PasswordRequirementsPopup;
